export const buildTrackingMeasurementContext = (user, measurementContext, isInternalMeasurementUser) => ({
    user_id: measurementContext?.user_id || user?.id,
    account_id: measurementContext?.account_id,
    company_id: measurementContext?.company_id,
    company_domain: measurementContext?.company_domain,
    current_plan: measurementContext?.current_plan,
    is_internal_user: Boolean(isInternalMeasurementUser),
    internal_traffic: Boolean(isInternalMeasurementUser),
    internal_account: Boolean(measurementContext?.internal_account),
    internal_reason: measurementContext?.internal_reason
});
